module.exports = __webpack_public_path__ + "img/service-launch-1.4250c220.png";